var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"resource":_vm.resource}},[_c('iframe',{staticClass:"ts-w-full ts-h-full",staticStyle:{"height":"70vh"},attrs:{"src":_vm.resource.storage_path,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }